export default {
  props: {
    className: {
      default: () => {},
    },
    name: {
      type: String,
      default: () => {},
    },
    theme: {
      type: String,
      default: 'default',
    },
    type: {
      type: String,
      default: 'button',
    },
    text: {
      type: String,
      default: '',
    },
    iconLeft: {
      type: String,
      default: '',
    },
    iconRight: {
      type: String,
      default: '',
    },
    iconSize: {
      type: Number,
      default: 1.3,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dataTest: {
      type: String,
      default: null,
    },
  },
  computed: {
    internalDisabled() {
      return this.disabled || this.loading;
    },
  },
  methods: {
    getClasses() {
      const temp = ['gotu-nav-button', this.theme, this.className];
      return temp.join(' ');
    },
    onClick(e) {
      if (this.disabled) {
        e.stopPropagation();
        e.preventDefault();
      } else {
        this.$emit('click', e);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/gotu-nav-button/GotuNavButton.js